<div class="flex flex-column gap-4 py-2">
  <!-- Welcome and Stats Section -->
  <div class="flex flex-column gap-2">
    <div class="flex justify-content-between align-items-center">
      <div class="flex align-items-center">
        <div>
          <h1 class="m-0 text-900 font-bold text-3xl">Dashboard</h1>
          <p class="text-500 mt-2">Bienvenido de nuevo, {{ username }}</p>
        </div>
      </div>
      <span class="text-xl text-700 font-medium">{{ currentDate | date:'dd/MM/yyyy' }}</span>
    </div>

    <app-stats />

    <!-- Kanban Summary Bar -->
    <div class="grid mt-1">
      <div class="col-12">
        <div
          class="surface-card shadow-1 p-3 border-round flex align-items-center justify-content-between border-left-3 border-indigo-500">
          <div class="flex align-items-center gap-4">
            <div class="flex flex-column">
              <span class="text-500 text-sm mb-1">Estado de tu Kanban</span>
              <div class="flex align-items-center gap-3">
                <div class="flex align-items-center gap-2">
                  <p-badge [value]="kanbanStats().pending.toString()" severity="info" />
                  <span class="text-700 font-medium">Pendientes</span>
                </div>
                <div class="flex align-items-center gap-2">
                  <p-badge [value]="kanbanStats().inProcess.toString()" severity="warning" />
                  <span class="text-700 font-medium">En Proceso</span>
                </div>
              </div>
            </div>
          </div>
          <p-button label="Ver Todo el Tablero" icon="pi pi-arrow-right" iconPos="right" [text]="true"
            routerLink="/kanban" />
        </div>
      </div>
    </div>
  </div>

  <!-- Main Content Grid -->
  <div class="grid">
    <!-- Charts Section -->
    <div class="col-12 xl:col-8">
      <app-chart />
    </div>

    <!-- Recent Activity and Kanban Insights -->
    <div class="col-12 xl:col-4">
      <div class="flex flex-column gap-4">

        <!-- Upcoming Events Card -->
        <p-card header="Mi Agenda" subheader="Próximos eventos" styleClass="shadow-2 border-round">
          <div class="flex flex-column gap-3 mt-2">
            @for (event of upcomingEvents(); track event.id) {
            <div
              class="flex align-items-center gap-3 p-2 surface-50 border-round hover:surface-100 transition-duration-150 cursor-pointer"
              routerLink="/calendar">
              <div class="flex flex-column align-items-center justify-content-center bg-primary-100 border-round p-2"
                style="min-width: 3.5rem;">
                <span class="text-primary-600 font-bold text-xl">{{ event.attributes.start | date:'dd' }}</span>
                <span class="text-primary-500 text-xs uppercase">{{ event.attributes.start | date:'MMM' }}</span>
              </div>
              <div class="flex flex-column flex-grow-1 overflow-hidden">
                <span
                  class="text-900 font-semibold text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis">{{
                  event.attributes.title }}</span>
                <span class="text-500 text-xs">
                  {{ event.attributes.allDay ? 'Todo el día' : (event.attributes.start | date:'HH:mm') }}
                </span>
              </div>
              <div [style.background-color]="event.attributes.color || '#3498db'" class="border-circle"
                style="width: 0.75rem; height: 0.75rem;"></div>
            </div>
            } @empty {
            <div class="flex flex-column align-items-center justify-content-center py-4 text-400">
              <i class="pi pi-calendar-plus text-4xl mb-2"></i>
              <span>No hay eventos próximos</span>
            </div>
            }
          </div>
          <ng-template pTemplate="footer">
            <p-button label="Ir al Calendario" [text]="true" size="small" routerLink="/calendar" class="w-full" />
          </ng-template>
        </p-card>

        <!-- Critical Tasks Card -->
        <p-card header="Mis Tareas Críticas" subheader="Prioridad alta pendientes" styleClass="shadow-2 border-round">
          <div class="flex flex-column gap-3 mt-2">
            @for (task of highPriorityTasks(); track task.id) {
            <div
              class="flex align-items-center justify-content-between p-2 surface-50 border-round border-left-3 border-red-500 hover:surface-100 transition-duration-150 cursor-pointer"
              routerLink="/kanban">
              <div class="flex flex-column gap-1 overflow-hidden pr-2">
                <span
                  class="text-900 font-semibold text-sm white-space-nowrap overflow-hidden text-overflow-ellipsis">{{
                  task.attributes.title }}</span>
                <span class="text-500 text-xs">{{ task.attributes.status === 'pending' ? 'Pendiente' : 'En Proceso'
                  }}</span>
              </div>
              <i class="pi pi-chevron-right text-400 text-xs text-shrink-0"></i>
            </div>
            } @empty {
            <div class="flex flex-column align-items-center justify-content-center py-4 text-400">
              <i class="pi pi-check-circle text-4xl mb-2 text-green-400"></i>
              <span>¡Al día! No hay tareas críticas.</span>
            </div>
            }
          </div>
          <ng-template pTemplate="footer" *ngIf="highPriorityTasks().length > 0">
            <p-button label="Administrar Tareas" [text]="true" size="small" routerLink="/kanban" class="w-full" />
          </ng-template>
        </p-card>

        <app-last-services />
        <app-last-budgets />
      </div>
    </div>
  </div>
</div>